import enUS from './en-US';
import ptBR from './pt-BR';
import zhCN from './zh-CN';
export default {
    "en-us": enUS,
    "pt-br": ptBR,
    "zh-cn": zhCN
}